export default __webpack_public_path__ + "static/tvw-13fa98e7551ec4e8d85a833b34126ea8.png";